document.addEventListener("DOMContentLoaded", () => {
    var searchApps = document.querySelectorAll(".search-app");
    if (searchApps) {
        searchApps.forEach((searchApp) => {
            new Vue({
                el: "#" + searchApp.id,
                data: {
                    query: '',
                    submittedQuery: '',
                    results: [],
                    resultsCount: null,
                    isLoading: false,
                    error: null
                },
                created() {
                    // Check for initial query in URL
                    const urlParams = new URLSearchParams(window.location.search);
                    const initialQuery = urlParams.get('q');
                    if (initialQuery) {
                        this.query = decodeURIComponent(initialQuery);
                        this.performSearch(); // Trigger initial search if query exists in URL
                    }
                },
                methods: {
                    async performSearch() {
                        if (!this.query.trim()) return;

                        this.isLoading = true;
                        this.error = null;

                        try {
                            const encodedQuery = encodeURIComponent(this.query);

                            const response = await fetch(
                                `/api/search/search?query=${encodedQuery}`
                            );
                            if (!response.ok) {
                                this.error =
                                    "There was an error processing your search. Please try again.";
                                return;
                            }

                            const data = await response.json();
                            //console.log("DATA", data);
                            this.submittedQuery = this.query;
                            this.results = data.results || [];
                            this.resultsCount = data.resultCount || 0;
                            this.updateUrlParameter();
                        } catch (e) {
                            this.error =
                                "Der skete en uventet fejl. Prøv igen senere.";
                        } finally {
                            this.isLoading = false;
                        }
                    },
                    updateUrlParameter() {
                        // Get the current URL without parameters
                        const baseUrl = window.location.origin + window.location.pathname;

                        // Check if there are any existing parameters
                        const existingParams = new URLSearchParams(window.location.search);

                        // If there are existing parameters, append the query parameter using '&'
                        if (existingParams.size > 0) {
                            existingParams.set('q', encodeURIComponent(this.query));
                            const newUrl = baseUrl + '?' + existingParams.toString();
                            window.history.pushState({}, null, newUrl);
                        } else {
                            // If there are no existing parameters, add the query parameter using '?'
                            const newUrl = baseUrl + '?q=' + encodeURIComponent(this.query);
                            window.history.pushState({}, null, newUrl);
                        }
                    }
                }
            });
        });
    }
});
